
export class ChangelogCtrl
{
	resultOptions = {
		boundaryLinks: false,
		limitSelect: true,
		pageSelect: true
	};
	limitOptions = [10, 20, 50, 100];
	query = {
		order: '-id',
		limit: 20,
		page: 1,
		filters: {}
	};
	defaultQuery = {
		order: '-id',
		limit: 20,
		page: 1,
		filters: {}
	};
	promise;
	data = [];
	total = 0;
	initialized = false;
	
	$filter;
	$scope;
	notify;
	jsDataService;
	$http;
	$mdDialog;
	
	constructor($scope, $filter, $http, $mdDialog, jsDataService, notify){
		'ngInject';
		this.$filter = $filter;
		this.$scope = $scope;
		this.$http = $http;
		this.$mdDialog = $mdDialog;
		this.notify = notify;
		this.jsDataService = jsDataService;
	}
	
	$onInit(){
		this.initialized = true;
		this.initQuery();
	}
	
	initQuery(){
		this.query = angular.merge({}, this.defaultQuery);
		const self = this;
		this.$scope.$watch(function(){
			return angular.toJson(self.query);
		},function(){
			self.loadData();
		});
		
	}
	
	loadData(){
		if(this.initialized){
			const url = this.jsDataService.get('cfgDataUrl');
			if(url){
				const self = this;
				this.promise = this.$http({
					url: url,
					method: 'GET',
					params: this.query
				}).then(function(response){
					if(response.data.success){
						self.data = response.data.data;
						self.total = response.data.total;
					}
					if(response.data.message){
						self.notify(response.data.message, !response.data.success);
					}
				}, function(response){
					console.log("HTTP ERROR");
					console.log(response);
				});
			}
		}
	}
	
	imagePreview(e, image){
		this.$mdDialog.show({
			controller: "ImagePreviewCtrl",
			templateUrl: 'itemattachments/image_preview.html',
			parent: angular.element(document.body),
			targetEvent: e,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				image: image
			}
		}).then(function(result) {}, function () {});
	}
	
	documentPreview(e, doc){
		this.$mdDialog.show({
			controller: "MessagePreview",
			templateUrl: 'reports/message_preview.html',
			parent: angular.element(document.body),
			targetEvent: e,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				id: doc.id
			}
		})
		.then(function(result) {
			
		}, function () {

		});
	}
}

